import { render, staticRenderFns } from "./AddEditAnnouncement.vue?vue&type=template&id=2ee6d4ed&scoped=true&"
import script from "./AddEditAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AddEditAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee6d4ed",
  null
  
)

export default component.exports